import { createConsumer, logger } from '@rails/actioncable';

if (window.env === 'development') {
  logger.enabled = true;
}

export const consumer = createConsumer();
